module.exports = __webpack_public_path__ + "img/tuurro.c6.b.b36de87c.png";